import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ErrorsService } from '../../modules/shared/services/errors.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalysisMessages } from '../../modules/shared/models/component-messages/analysis-messages';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public mapLang = new Map<any, any>();
  public title = 'eSignature';
  public error = false;
  public currentLanguage;
  public currentLanguageCode;
  public analysisMessage = new AnalysisMessages();
  public windowScrolled: boolean;
  public currentUrl: string = "";

  constructor(private errorsService: ErrorsService, public translate: TranslateService, public router: Router,
              private renderer: Renderer2) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url != "") {
          this.currentUrl = e.url.replace("#main", "");
        } else {
          this.currentUrl = "";
        }
      }
    });
  }

  public ngOnInit() {
    this.mapLang = new Map([
      ['fr', 'language.french'],
      ['en', 'language.english'],
    ]);
    this.error = this.errorsService.error;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLanguageCode = event.lang;
      this.currentLanguage = this.mapLang.get(event.lang);
      this.updateMenuLanguageSelector();
      this.renderer.setAttribute(document.querySelector('html'), 'lang', event.lang);
    });
  }

  public closeMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '0';
    }
    if (document.getElementById('opacity').style.display != null) {
      document.getElementById('opacity').style.display = 'none';
    }
  }

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    } else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }

  public scrollToTop() {
    (function smoothScroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothScroll);
        window.scrollTo(0, 0);
      }
    })();
  }

  private updateMenuLanguageSelector() {
    if (document.getElementById('selector') != null) {
      const selector = document.getElementById('selector');
      if (this.currentLanguageCode === 'fr') {
        selector[0].selected = true;
      }
      if (this.currentLanguageCode === 'en') {
        selector[1].selected = true;
      }
    }
  }
}

